(ns frontend.view.nev.kyc.process.kyc-editor
  (:require
   [basic-components.inputs.footprint :refer [viewer]]
   [common.localization :as loc]
   [common.schema.entities.workspace.kyc.kyc-utils :as ku]
   [frontend.view.nev.kyc.process.editor-utils :as editor-utils]
   [frontend.view.nev.kyc.process.editors :as editors]
   [frontend.view.nev.kyc.process.file-editor :as file-editor]
   [frontend.view.nev.kyc.process.info-editor :as info-editor]
   [frontend.view.nev.kyc.process.data-enrichment :refer [data-enrichment-button]]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.logging :as logging]
   [basic-components.field-editor :as field-editor]
   [frontend.view.nev.kyc.process.checkbox-editor :as checkbox-editor]
   [common.util :as cu]
   [reagent.core :as r]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.dynamic.view :as dynamic-modal]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.util :as uu]
   [frontend.tenant-customizations :as tenant-customizations]))

(defn complex-print
  [kyc-entity-editor process-id state-atom lang-kw q m answers-atom mandatory? read-only? save!]
  (let [value (get @answers-atom q)]
    (when (= :edn-data.type/ubo-list (:edn-data/type m))
      [:div
       (->> value
            (sort-by :ord)
            (map-indexed
             (fn [idx ubo]
               (let [ubo-answers (r/atom (or ubo {}))
                     ubo-template-schema (:data/template m)]
                 ^{:key (str "Print-ubo-" idx)}
                 [:div
                  [:h2.container.pb-3
                   (loc/tr :ubo-print [(:kyc-ubo/first-name ubo) (:kyc-ubo/last-name ubo)])]

                  [kyc-entity-editor
                   {:container-id    (str "PRINT-UBO-" idx)
                    :process-id      process-id
                    :state-atom      state-atom
                    :answers-atom    ubo-answers
                    :skip-info?      true
                    :save            save!
                    :mandatory?      mandatory?
                    :read-only?      read-only?
                    :template-schema ubo-template-schema
                    :lang-kw         lang-kw} nil]]))))])))
#_(when (= :edn-data.type/pep-list (:edn-data/type m))
    [:div
     #_(->> value
            (sort-by :ord)
            (map-indexed
             (fn [idx pep]
               (let [pep-answers (r/atom (or pep {}))
                     pep-template-schema (:data/template m)]
                 ^{:key (str "Print-pep-" idx)}
                 [:div
                  [:h2.container.pb-3 (loc/tr :pep-print [(ku/pep-display-name pep)])]
                  [kyc-entity-editor
                   {:container-id    (str "PRINT-pep-" idx)
                    :process-id      process-id
                    :state-atom      state-atom
                    :answers-atom    pep-answers
                    :skip-info?      true
                    :save            save!
                    :mandatory?      mandatory?
                    :read-only?      read-only?
                    :template-schema pep-template-schema
                    :lang-kw         lang-kw} nil]]))))])

(defn field-editor-extra-info
  [{:keys [question question-meta lang-kw]}]
  (cond
    (= question :kyc-tenant/industry)
    (let [desc-1 (loc/tr :tenant-kyc-industry-desc-1 nil lang-kw)
          desc-2 (loc/tr :tenant-kyc-industry-desc-2 nil lang-kw)
          link "https://ec.europa.eu/competition/mergers/cases/index/nace_all.html"]
      [:div.mt-2.mb-2
       {:style {:font-size "14px"
                :color     "#888C81"}}
       [:span desc-1]
       [:a
        {:href   link
         :target "_blank"
         :style  {:color "#8ABF4C"}}
        link]
       [:span (str ". " desc-2)]
       [:br]
       [:span (loc/tr :tenant-kyc-industry-desc-3 nil lang-kw)]])

    (and (get-in question-meta [:info lang-kw])
         (-> question-meta
             :info-position
             (= :below-input)))
    (let [info-text (get-in question-meta [:info lang-kw])]
      [:div
       [:p
        {:class "pt-1 text-sm m-0"}
        info-text]])

    :else nil))

(defn field-editor-extra-info-above-input
  [{:keys [question-meta lang-kw]}]
  (when (and (get-in question-meta [:info lang-kw])
             (-> question-meta
                 :info-position
                 (= :above-input)))
    (let [info-text (get-in question-meta [:info lang-kw])]
      [:div
       [:p
        {:class "pb-2 text-sm m-0"}
        info-text]])))

(defn info-block-container-style
  []
  (cond-> {}
    (tenant-customizations/capman?)
    (merge {"--kyc-info-color" "var(--base-light-text-paler)"
            "--kyc-info-strong-color" "var(--base-light-text-paler)"})))

(defn kyc-entity-editor
  [{:keys [container-id
           process-id state-atom answers-atom
           save!
           loading-atom
           skip-info?
           read-only? print?
           field-errors-atom
           mandatory? template-schema lang-kw]} validate-state]
  (let [kyc-process (session/get-entity process-id)
        complex-fields (atom {})
        answers @answers-atom]
    (when validate-state
      (swap! validate-state assoc :value true))
    [:div
     (->>
      template-schema
      (remove (fn [[_section-kw section-meta]]
                (editor-utils/hide-section? answers kyc-process section-meta)))
      (sort-by (fn [[_section-kw metadata]]
                 (:ord metadata)))
      (map
       (fn [[section-kw section-metadata]]
         (let [full-width-section? (:full-width-section? section-metadata)
               info-only-section? (:info-only-section? section-metadata)]
           [:div.container
            {:key (str "kyc-section-" container-id "-" (:ord section-metadata))}

            [:div.card--kyc
             [:div.card-header
              [:h3
               (-> section-metadata
                   :translations
                   (get lang-kw))]]
             [:div.card-body
              [:div
               {:class-name "grid grid-cols-10 gap-6"}
               [:div
                {:class-name (fu/cs "col-span-10"
                                    (when (and (not read-only?)
                                               (not skip-info?)
                                               (not full-width-section?))
                                      "col-span-6")
                                    (when full-width-section?
                                      "col-span-10")
                                    (when info-only-section?
                                      "hidden"))}
                [:ul
                 [data-enrichment-button
                  {:section-kw   section-kw
                   :kyc-process  kyc-process
                   :answers-atom answers-atom
                   :state-atom   state-atom
                   :loading-atom loading-atom
                   :lang-kw      lang-kw
                   :save!        save!}]
                 (->>
                  section-metadata
                  :questions
                  (remove (fn [[_ m]]
                            (editor-utils/hide-question? answers kyc-process m)))
                  (sort-by (fn [[_ m]]
                             (:ord m)))
                  (keep
                   (fn [[q m]]
                     (let [data-type (:data/type m)
                           editor-type (or (:editor/type m)  ; Use explicit editor type if defined
                                           (case data-type
                                             :data.type/text-simple :editor.type/text-simple
                                             :data.type/text :editor.type/text-simple
                                             :data.type/boolean :editor.type/toggle
                                             :data.type/date :editor.type/date
                                             :data.type/datetime :editor.type/datetime
                                             :data.type/text-multiline :editor.type/textarea
                                             :data.type/keyword :editor.type/select
                                             :data.type/keyword-multi :complex-editor
                                             :data.type/email :editor.type/email
                                             :data.type/currency-value :editor.type/number
                                             :data.type/text-url :editor.type/url
                                             :data.type/text-edn :complex-editor
                                             :data.type/confirm :editor.type/checkbox
                                             :data.type/percentage :editor.type/percentage
                                             :data.type/file :file
                                             :data.type/info :info
                                             (logging/error "Data type not implemented in KYC form " q
                                                            " -> " (pr-str m))))
                           value (get @answers-atom q)
                           opts (ku/active-options (:options m) value)
                           custom-sort? (some->> opts
                                                 (remove :ord)
                                                 (empty?))
                           options (some->> opts
                                            (map (fn [op]
                                                   (merge
                                                    {:key     (:key op)
                                                     :keyword (:keyword op)
                                                     :ord     (:ord op)
                                                     :label   (or (some-> op
                                                                          :translations
                                                                          (get lang-kw))
                                                                  (:label op)
                                                                  "unknown")}
                                                    (when (contains? op :value)
                                                      {:value (:value op)})
                                                    (when (:disabled? op)
                                                      {:disabled? true}))))
                                            (sort-by (fn [opt]
                                                       (if custom-sort?
                                                         (:ord opt)
                                                         (:label opt))))
                                            (vec))]
                       (when (or (not read-only?)
                                 (not= data-type :data.type/confirm)) ;; do not show confirm types in read-only mode
                         [:li.mb-4.px-3
                          {:key (str container-id "-" (:ord section-metadata) "-" (:ord m))
                           :id  (str container-id "-" (:ord section-metadata) "-" (:ord m))}
                          [field-editor-extra-info-above-input
                           {:question      q
                            :question-meta m
                            :lang-kw       lang-kw}]
                          (cond
                            (= editor-type :complex-editor)
                            (do
                              (swap! complex-fields assoc q m)
                              [editors/complex-editor
                               {:kyc-entity-editor  kyc-entity-editor
                                :process-id         process-id
                                :kyc-process        kyc-process
                                :state-atom         state-atom
                                :lang-kw            lang-kw
                                :question-attribute q
                                :question-meta      m
                                :answers-atom       answers-atom
                                :mandatory?         (and mandatory?
                                                         (editor-utils/mandatory?
                                                          q
                                                          m
                                                          answers
                                                          kyc-process))
                                :read-only?         read-only?
                                :save!              save!}])
                            (= editor-type :file)
                            [file-editor/file-editor
                             {:process-id   process-id
                              :lang-kw      lang-kw
                              :q            q
                              :m            m
                              :answers-atom answers-atom
                              :mandatory?   (and mandatory?
                                                 (editor-utils/mandatory?
                                                  q
                                                  m
                                                  answers
                                                  kyc-process))
                              :read-only?   read-only?
                              :save!        save!}]
                            (= editor-type :info)
                            [info-editor/editor
                             {:lang-kw       lang-kw
                              :question-meta m}]

                            (= editor-type :editor.type/checkbox)
                            [checkbox-editor/view
                             {:lang-kw            lang-kw
                              :answers-atom       answers-atom
                              :question-attribute q
                              :question-meta      m
                              :mandatory?         mandatory?
                              :read-only?         read-only?
                              :save!              save!
                              :value              value
                              :on-change          (fn [checked?]
                                                    (swap! answers-atom assoc q checked?)
                                                    (deref answers-atom)
                                                    (save!))}]

                            :else
                            (if-not read-only?
                              [:div
                               [labelled-input/view
                                (merge
                                 {:label (-> m
                                             :translations
                                             (get lang-kw))
                                  :data-type data-type
                                  :options (->> options
                                                (mapv (fn [opt]
                                                        (if-not (contains? opt :value)
                                                          (assoc opt :value (:key opt))
                                                          opt))))
                                  :value value
                                  :on-focus (fn [_attribute]
                                              (when-not (contains? #{:below-input :above-input} (:info-position m))
                                                (swap! state-atom assoc
                                                       :focused-info (some-> m
                                                                             :info
                                                                             (get lang-kw))
                                                       :focused-block (:ord section-metadata))
                                                (deref state-atom)))
                                  :is-clearable? true
                                  :on-blur (fn [value]
                                             (swap! state-atom dissoc
                                                    :focused-info
                                                    :focused-block)
                                             ;; TODO: Not sure which editor types provide the latest value in the
                                             ;; callback function, and if that can differ from the latest on-change value
                                             (when (#{:editor.type/text-simple
                                                      :editor.type/textarea
                                                      :editor.type/percentage} editor-type)
                                               (swap! answers-atom assoc q value)
                                               (deref state-atom))
                                             (save!))
                                  :on-change (fn [value _second-arg]
                                               (if (empty? (cu/str-trim value))
                                                 (swap! answers-atom dissoc q)
                                                 (swap! answers-atom assoc q value))
                                               (when (or (#{:editor.type/select} editor-type)
                                                         (#{:data.type/keyword
                                                            :data.type/boolean
                                                            :data.type/keyword-multi} data-type))
                                                 (deref answers-atom)
                                                 (save!)))
                                  :on-error! (fn [error]
                                               (when field-errors-atom
                                                 (swap! field-errors-atom assoc q error)))
                                  :clear-error! (fn []
                                                  (when field-errors-atom
                                                    (swap! field-errors-atom dissoc q)))
                                  :date-format (or (:tenant/date-format @session/tenant)
                                                   (loc/tr :date-format))
                                  :mandatory? (and mandatory?
                                                   (editor-utils/mandatory?
                                                    q
                                                    m
                                                    answers
                                                    kyc-process))}
                                 (when (or (#{:data.type/confirm} data-type)
                                           (#{:editor.type/checkbox :editor.type/radio} editor-type))
                                   {:editor-type editor-type}))]]

                              ;; Leave old editor as read only version
                              [field-editor/view
                               {:editor/type           editor-type
                                :close-menu-on-scroll? true
                                :menu-portal-target    (.getElementById
                                                        js/document
                                                        "react-select-menu-container")
                                :value                 value
                                :draggable?            false
                                :state-atom            answers-atom
                                :refresh-info-atom     loading-atom
                                :class-name            (:style m)
                                :attribute             q
                                :label                 (-> m
                                                           :translations
                                                           (get lang-kw))
                                :value-type            (case (:data/type m)
                                                         :data.type/keyword-multi :keyword
                                                         :data.type/keyword :keyword
                                                         nil)
                                :on-focus              (fn [_attribute]
                                                         (swap! state-atom assoc
                                                                :focused-info (some-> m
                                                                                      :info
                                                                                      (get lang-kw))
                                                                :focused-block (:ord section-metadata))
                                                         (deref state-atom))
                                :on-blur               (fn [_attribute]
                                                         (swap! state-atom dissoc
                                                                :focused-info
                                                                :focused-block)
                                                         (deref state-atom))
                                :hide-label?           false
                                :on-save!              (fn [attribute new-value]
                                                         (if (empty? (cu/str-trim new-value))
                                                           (swap! answers-atom dissoc attribute)
                                                           (swap! answers-atom assoc
                                                                  attribute
                                                                  new-value))
                                                         (save!))
                                :on-change             (fn [attribute new-value]
                                                         (if (empty? (cu/str-trim new-value))
                                                           (swap! answers-atom dissoc attribute)
                                                           (swap! answers-atom assoc
                                                                  attribute
                                                                  new-value)))
                                :mandatory?            (and mandatory?
                                                            (editor-utils/mandatory?
                                                             q
                                                             m
                                                             answers
                                                             kyc-process))
                                :disabled?             false
                                :read-only?            (and read-only?
                                                            (or (not (:section-not-read-only
                                                                      section-metadata))
                                                                (not ((:section-not-read-only
                                                                       section-metadata)
                                                                      @answers-atom
                                                                      kyc-process))))
                                :custom-ordering?      true
                                :field/custom-sort     true
                                :tools                 (when-not read-only?
                                                         [:tool-item/clear :tool-item/cancel])
                                :options               options
                                :children              (:children m)
                                :selection-mode        (:selection-mode m)
                                :parent-label          (-> m :translations (get lang-kw))
                                :lang-kw               lang-kw
                                :drag-options          {:hide-drag-area? true}}]))

                          [field-editor-extra-info
                           {:question      q
                            :question-meta m
                            :lang-kw       lang-kw}]

                          (when-not read-only?
                            (let [field-error (when field-errors-atom
                                                (get @field-errors-atom q))
                                  deprecated? (ku/value-deprecated? (:options m) value)
                                  message (cond
                                            field-error (str field-error)
                                            deprecated? (loc/tr :deprecated-value-please-reselect nil lang-kw))]
                              (when message
                                [:p
                                 {:class "text-sm m-0 mt-1 text-danger-light-text"}
                                 message])))]))))
                  (doall))]]
               (when (or info-only-section?
                         (and (not read-only?)
                              (not skip-info?)
                              (not full-width-section?)))
                 [:div
                  {:class-name (uu/cm "col-span-4 kyc-info-block"
                                      (when info-only-section?
                                        "pl-0 border-0 col-span-10 md:col-span-6 lg:col-span-5")
                                      (when (tenant-customizations/capman?)
                                        "text-base-light-text-paler!"))
                   :style (info-block-container-style)}
                  [viewer
                   {:editor/type :editor.type/wysiwyg
                    :value       (or (when (= (:ord section-metadata) (:focused-block @state-atom))
                                       (when-let [info (:focused-info @state-atom)]
                                         (when-not (empty? (cu/str-trim info))
                                           info)))
                                     (some-> section-metadata
                                             :info
                                             (get lang-kw))
                                     "")}]
                  (when-let [more-info (some-> section-metadata
                                               :more-info)]
                    [:div.preview
                     [:a
                      {:href     "#"
                       :on-click (fn []
                                   (modals/open-modal!
                                    dynamic-modal/modal-key
                                    {:title        (some-> more-info
                                                           :info-header
                                                           (get lang-kw))
                                     :custom-class "discovery-profile-modal"
                                     :render-fn    (fn [_state _close-modal!]
                                                     [:div.kyc-info-block.kyc-info-block--no-line
                                                      {:style (info-block-container-style)}
                                                      [viewer
                                                       {:editor/type :editor.type/wysiwyg
                                                        :value       (str (some->
                                                                           more-info
                                                                           :info-content
                                                                           (get lang-kw)))}]])}))}
                      (str (some-> more-info
                                   :link-text
                                   (get lang-kw)))]])])]]]])))
      (doall))

     (when print?
       (->> @complex-fields
            (keep (fn [[q m]]
                    (when-let [print-hiccup (complex-print kyc-entity-editor
                                                           process-id
                                                           state-atom
                                                           lang-kw
                                                           q
                                                           m
                                                           answers-atom
                                                           false
                                                           true
                                                           identity)]
                      [:div
                       {:key (str "print-" q)}
                       print-hiccup])))
            (doall)))]))
